var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',{staticClass:"nftmax-dsinner"},[_c('div',{staticClass:"nftmax-inner__heading mg-btm-20"},[_c('h2',{staticClass:"nftmax-inner__page-title mb-0"},[_vm._v("All Saved")])]),_c('MainSection'),_c('UploadProductSectionWidget')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }